import { render, staticRenderFns } from "./CrudCard.vue?vue&type=template&id=1cc95e69&"
import script from "./CrudCard.vue?vue&type=script&lang=js&"
export * from "./CrudCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports